import { render, staticRenderFns } from "./coupon-code.vue?vue&type=template&id=5c57477e"
import script from "./coupon-code.vue?vue&type=script&lang=js"
export * from "./coupon-code.vue?vue&type=script&lang=js"
import style0 from "./coupon-code.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports